<template>
  <div class="news-detail-page">
    <div class="container">
      <!-- 返回按钮 -->
      <router-link to="/" class="back-button">
        <i class="fas fa-arrow-left"></i> 返回新闻列表
      </router-link>

      <div class="news-content-wrapper">
        <!-- 新闻标题和日期 -->
        <div class="news-header">
          <h1 class="news-title">{{ newsItem.title }}</h1>
          <div class="news-meta">
            <span class="news-date">{{ formatFullDate(newsItem.date) }}</span>
            <span class="news-author" v-if="newsItem.author">作者: {{ newsItem.author }}</span>
          </div>
        </div>

        <!-- 新闻封面图 -->
        <div class="news-cover">
          <img :src="newsItem.image" :alt="newsItem.title">
        </div>

        <!-- 新闻内容 -->
        <div class="news-body" v-html="newsItem.content"></div>
      </div>

      <!-- 相关新闻 -->
      <div class="related-news" v-if="relatedNews.length > 0">
        <h2 class="related-title">相关新闻</h2>
        <div class="related-grid">
          <router-link
              v-for="item in relatedNews"
              :key="item.id"
              :to="`/news/${item.id}`"
              class="related-card"
          >
            <img :src="item.image" :alt="item.title">
            <h3>{{ item.title }}</h3>
            <span class="related-date">{{ formatDate(item.date) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data() {
    return {
      newsItem: {},
      relatedNews: []
    }
  },
  created() {
    this.fetchNewsDetail()
  },
  methods: {
    fetchNewsDetail() {
      const newsId = this.$route.params.id
      // 这里应该是API请求，我们暂时用模拟数据
      const allNews = [
        {
          id: 1,
          title: '学校师生作品入选全国美展',
          content: '<p>我院10位师生作品成功入选第十三届全国美术作品展览，展现了学校教学成果...</p><p>全国美术作品展览是国内最高规格、最大规模的美术作品展览，每五年举办一次...</p>',
          date: '2023-05-15',
          image: require('@/assets/images/new1.png'),
          author: '教务处'
        },
        {
          id: 2,
          title: '国际艺术交流周圆满落幕',
          content: '<p>为期一周的国际艺术交流活动吸引了来自8个国家的艺术家参与，举办了多场工作坊...</p>',
          date: '2023-04-28',
          image: require('@/assets/images/new2.png'),
          author: '国际交流处'
        },
        {
          id: 3,
          title: '2023年毕业展盛大开幕',
          content: '<p>"创·无界"2023毕业作品展在校美术馆开幕，展出200余件毕业生作品...</p>',
          date: '2023-06-10',
          image: require('@/assets/images/new3.png'),
          author: '学生处'
        }
      ]

      this.newsItem = allNews.find(item => item.id === parseInt(newsId)) || {}

      // 获取相关新闻（模拟数据，实际应该根据某种关联关系获取）
      this.relatedNews = allNews.filter(item => item.id !== parseInt(newsId)).slice(0, 3)
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return `${date.getMonth() + 1}月${date.getDate()}日`
    },
    formatFullDate(dateString) {
      const date = new Date(dateString)
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
    }
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.fetchNewsDetail()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.news-detail-page {
  padding: 60px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.news-content-wrapper {
  width: 100%;
  max-width: 840px; /* 70% of 1200px */
}

.back-button {
  display: inline-block;
  margin-bottom: 30px;
  color: var(--default-red-color);
  text-decoration: none;
  font-weight: bold;
  align-self: flex-start;
}

.back-button:hover {
  text-decoration: underline;
}

.news-header {
  margin-bottom: 30px;
}

.news-title {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 10px;
}

.news-meta {
  color: #7f8c8d;
  font-size: 0.9rem;
}

.news-meta span {
  margin-right: 15px;
}

.news-cover {
  margin-bottom: 30px;
}

.news-cover img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.news-body {
  line-height: 1.8;
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 60px;
}

.news-body >>> p {
  margin-bottom: 1.5em;
}

.related-news {
  border-top: 1px solid #eee;
  padding-top: 40px;
  width: 100%;
  max-width: 1200px;
}

.related-title {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 30px;
}

.related-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.related-card {
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
}

.related-card:hover {
  transform: translateY(-5px);
}

.related-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 10px;
}

.related-card h3 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: #2c3e50;
}

.related-date {
  font-size: 0.8rem;
  color: #7f8c8d;
}

@media (max-width: 768px) {
  .news-content-wrapper {
    width: 100%;
    max-width: 100%;
  }

  .news-title {
    font-size: 1.6rem;
  }

  .news-body {
    font-size: 1rem;
  }
}
</style>
